import React, {FC} from "react";
import classNames from "classnames";
import defaultImage from "../../images/defaultpic.webp";
import {IBlogsLocale} from "../../types/pages";
import {createRightDate, replaceDescr} from "../../services/utils";
import cls from "./blog.module.scss"
import {domainUrl} from "../../helper";
import Image from "next/image";

interface IBlogPostProps {
    blog?: IBlogsLocale,
    dbName: string,
    domain: string,
    layout?: string,
    forBLogType: string
}

const BlogPost: FC<IBlogPostProps> = (props) => {
    const {layout, blog, domain, dbName, forBLogType} = props;


    const postClasses = classNames(cls.typography,
        layout === "full" && cls["typography--expanded"]
    );

    if (!blog) {
        return null;
    }
    const createMarkup = (item: string) => {
        return {__html: item};
    };

    let rightDate = blog.published_at ? createRightDate(blog.published_at) : createRightDate(blog.created_at)
    const blogDefaultImage = blog.image ? domainUrl(`${dbName}/storage/${domain}/${blog.image}`) : domainUrl(`${dbName}${defaultImage.src}`)

    return (
        <div className={`block ${cls[`post--layout--${layout}`]}`}>
            <div
                className={cls[`post-header--layout--${layout}`]}
            >
                <h1 className={cls["post-header__title"]}>
                    {forBLogType === "blog" ? blog.blog_title : blog.name}
                </h1>
                <div className={cls["post-header__meta"]}>
                    <div className={cls["post-header__meta-item"]}> {rightDate}</div>
                </div>
            </div>

            <div className={cls.post__featured}>
                <Image
                    src={blogDefaultImage}
                    alt="Blog Image"
                    placeholder="blur"
                    layout="fill"
                    priority
                    blurDataURL={`/zega/blur1.webp`}
                />
            </div>

            <div
                className={postClasses}
                dangerouslySetInnerHTML={createMarkup(replaceDescr(forBLogType === "blog" ? blog.html_content : blog.description))}
            />
        </div>
    );
}

export default BlogPost